import {apiHelper,PromiseHandler} from "../redux/apiHelper"

const getExpediteVisitConfig = () => PromiseHandler(apiHelper('get', `/api/admin/expedite-visit/get`))
const updateExpediteVisitConfig = (data) => PromiseHandler(apiHelper('post', `/api/admin/expedite-visit/update`, data))
const addExpediteVisitOption = (data) => PromiseHandler(apiHelper('post', `/api/admin/expedite-visit/option/add`, data))
const updateExpediteVisitOption = (id, data) => PromiseHandler(apiHelper('post', `/api/admin/expedite-visit/option/edit/${id}`, data))
const deleteExpediteVisitOption = (id) => PromiseHandler(apiHelper('post', `/api/admin/expedite-visit/option/delete/${id}`))
const reorderExpediteVisitOptions = (data) => PromiseHandler(apiHelper('post', `/api/admin/expedite-visit/options/reorder`, data))

export {
  getExpediteVisitConfig,
  updateExpediteVisitConfig,
  addExpediteVisitOption,
  updateExpediteVisitOption,
  deleteExpediteVisitOption,
  reorderExpediteVisitOptions
}


